exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js??ref--8-oneOf-1-1!../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../node_modules/postcss-loader/src/index.js??ref--8-oneOf-1-2!bootstrap/dist/css/bootstrap.css"), "");

// module
exports.push([module.id, ".error-content[data-v-3b144e58]{padding:20px 0;display:flex;flex-direction:column;gap:5px;align-items:center}.form-container>*[data-v-3b144e58]{opacity:0;transform:translateY(20px);animation:fadeIn-3b144e58 .6s forwards}@keyframes fadeIn-3b144e58{to{opacity:1;transform:translateY(0)}}", ""]);

// exports
